import HiddenVideo from './hidden-video'

export default HiddenVideo
